// Mirror of Tp_Communication.Constant.ComparisonOperatorConstants — values MUST stay identical.
const ComparisonOperatorEnum = {
  // Inactive sentinel: no comparison. The backend treats it as a no-op (default switch case).
  Any: 'any',
  GreaterThan: 'greaterThan',
  GreaterThanOrEqual: 'greaterThanOrEqual',
  LessThan: 'lessThan',
  LessThanOrEqual: 'lessThanOrEqual',
  Equal: 'equal',
  NotEqual: 'notEqual',
};

export default ComparisonOperatorEnum;
